import { userName, movement } from "../../../util/formatter";

export default {
  slug: "merchandisers",
  endpoint: "merchandisers/",
  titleKey: "merchandisers_title",
  defaultOrdering: "first_name",
  columns: [
    { label: "f_name", format: row => userName(null, row), sort: "first_name" },
    { field: "phone_number", label: "f_phone" },
    { label: "f_movement", format: row => movement(null, row) },
  ],
  deactivation: { field: "is_active", activeValue: true, via: "patch" },
  // detail + create stay in the existing rich merchandiser module:
  detailPath: id => `/merchandiser/${id}`,
  newPath: "/merchandiser/new",
};
